import styled from 'styled-components';

export const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 30px;
`;

export const ContainerIcon = styled.div`
  padding: 10px 5px;
`;

export const ContainerText = styled.div``;
